import {
  fetchClient
} from "./chunk-SKVXOXWB.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/hy/experiences/bySlug.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getExperiencesBySlug = (_0) => __async(void 0, [_0], function* ({ lang, city, slug }) {
  var _a;
  try {
    const locale = getLocaleOnly(lang);
    const citySlug = city === "all-cities" ? "everywhere" : city;
    const body = {
      lang,
      venue_url: `${citySlug}/${slug}`,
      venue_id: ""
    };
    const data = yield fetchClient({
      url: `/book/venue/detail?lang=${locale}`,
      options: {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          Authorization: ""
        }
      }
    });
    if (!((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.venue_id)) {
      throw new Error("No experience found");
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getExperiencesBySlugException"
    });
  }
});

export {
  getExperiencesBySlug
};
//# sourceMappingURL=chunk-MIEUWCQU.mjs.map